import React, { useMemo, useState } from 'react';

import { List, Popover } from 'antd';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import NwIcon from '@components/Gui/NwIcon';

import EventsSearchDrawer from '@containers/Booking/SearchEvents/EventsSearchDrawer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div``;

const Content = styled.div`
    padding: 0.25rem 0.75rem 0.5rem 0.75rem;
    min-width: 22rem;

    .popover-heading {
        padding: 6px 0;
        text-transform: uppercase;
        font-size: 0.7rem;
        font-weight: 600;
        color: ${(props) => props.theme?.TextMutedColor || '#8c8c8c'};
    }

    .ant-list-item {
        padding: 6px 0;
        cursor: pointer;

        &:hover {
            background-color: ${(props) => props.theme?.LightGrayColor || '#f5f5f5'};
        }

        &.selected {
            background-color: ${(props) => props.theme?.PrimaryColorLight || '#e6f7ff'};
        }

        .ant-list-item-meta {
            align-items: center;
        }

        .ant-list-item-meta-title {
            margin-bottom: 0;
            text-transform: uppercase;
            font-size: 0.8rem;
            font-weight: normal;
        }
    }
`;

const PreviousEventsButton = ({ modelID, eventData, clientIDs }) => {
    const [isClientListOpen, setIsClientListOpen] = useState(false);
    const [isOpenPreviousEventsDrawer, setIsOpenPreviousEventsDrawer] = useState(false);
    const [selectedClientID, setSelectedClientID] = useState(null);

    const clientNamesAndIDs = useMemo(() => {
        // if clientIDs are provided, use them
        if (clientIDs) {
            return clientIDs.map((id) => ({
                ID: id,
                Name: getContactName(id),
            }));
        }
        // otherwise, use the event data
        const eventClientID = eventData?.EventClientID;
        const projectClientID = eventData?.Project?.Contact?.ID;
        const ids = [];
        if (eventClientID && eventClientID !== projectClientID) {
            ids.push(eventClientID);
        }
        if (projectClientID) {
            ids.push(projectClientID);
        }
        return ids.map((id) => ({
            ID: id,
            Name: getContactName(id),
        }));
    }, [eventData]);

    const openDrawerForClient = (clientID) => {
        setSelectedClientID(clientID);
        setIsOpenPreviousEventsDrawer(true);
        setIsClientListOpen(false);
    };

    const handleSingleClientClick = () => {
        const onlyClient = clientNamesAndIDs[0];

        if (onlyClient) {
            openDrawerForClient(onlyClient.ID);
        }
    };

    return (
        <Wrapper className="previous-events-button">
            {clientNamesAndIDs.length > 1 ? (
                <Popover
                    // title="Select a client"
                    trigger="click"
                    open={isClientListOpen}
                    onOpenChange={setIsClientListOpen}
                    content={
                        <Content>
                            <div className="popover-heading">Select a client</div>
                            <List
                                itemLayout="horizontal"
                                dataSource={clientNamesAndIDs}
                                renderItem={(client) => (
                                    <List.Item
                                        onClick={() => openDrawerForClient(client.ID)}
                                        className={
                                            selectedClientID === client.ID
                                                ? 'selected client-list-item'
                                                : 'client-list-item'
                                        }
                                    >
                                        <List.Item.Meta
                                            avatar={<NwIcon icon={byPrefixAndName.fass['user']} />}
                                            title={client.Name || client.ID}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Content>
                    }
                >
                    <NwIcon pointer icon={byPrefixAndName.fasl['clock-rotate-left']} />
                </Popover>
            ) : (
                <NwIcon
                    pointer
                    icon={byPrefixAndName.fasl['clock-rotate-left']}
                    tooltip="Previous Events"
                    onClick={handleSingleClientClick}
                />
            )}

            {isOpenPreviousEventsDrawer && selectedClientID && (
                <EventsSearchDrawer
                    key={`previous-events-${modelID}-${selectedClientID}`}
                    visible={isOpenPreviousEventsDrawer}
                    modelId={modelID}
                    clientId={selectedClientID}
                    modelName={getContactName(modelID)}
                    clientName={getContactName(selectedClientID)}
                    eventTypes={['job']}
                    storageKey="previousevents"
                    defaultGroupByProject={true}
                    defaultShowTransactions={true}
                    defaultSort="time-down"
                    openFirstCollapse={true}
                    onClose={() => {
                        setIsOpenPreviousEventsDrawer(false);
                        setSelectedClientID(null);
                    }}
                />
            )}
        </Wrapper>
    );
};

export default PreviousEventsButton;
